import { call, put, select, takeEvery } from 'redux-saga/effects'
import { matchRoutes } from 'react-router-config'
import { last, findIndex, pick } from 'lodash'
import { parse } from 'query-string'
import routers from '@routers'
import { saveWorkbenchMenu } from '@saga/workbench'
import { setApplication } from '@actions/basic/header'
import { setMenuData, setLayout } from '@redux/actions/basic/layout'
import * as crumbActions from '@redux/actions/basic/crumbList'
import layoutTypes from '@redux/types/basic/layout'
import { setStore, getStore, removeStore } from '@utils/storage'
import {
  getMenuTopFistUrlPath,
  getAppMenuApplication,
  getAppMenuConfig
} from '@utils/menuUtils'
import { getMenus } from '@model/auth/auth-v2'

export function* getResApplication() {
  let menu = []
  try {
    const res = yield call(getMenus)
    // NOTE: 能否并行？
    if (res.success && res.data && res.data.length) {
      for (let i = 0; i < res.data.length; i++) {
        const appData = res.data[i]
        const app = {
          code: appData.code,
          name: appData.displayName,
          menu: appData.screenMenuList,
          icon: appData.icon,
          size: appData.size
        }
        app.path = getMenuTopFistUrlPath(app)
        menu.push(app)
      }
    }

    yield call(saveMenu, menu)
    yield call(saveWorkbenchMenu, menu)

    yield put({
      type: `${layoutTypes.GET_APPLICATIONS}@DONE`
    })
  } catch (error) {
    yield put({
      type: `${layoutTypes.GET_APPLICATIONS}@ERROR`,
      error
    })
  }
}

export function* saveMenu(menu) {
  let _menu = menu
  if (menu) {
    setStore('menus', _menu, 'local')
  } else {
    _menu = getStore('menus', 'local')
  }
  if (_menu && _menu.length) {
    yield put(setMenuData(_menu))
  }
  return _menu
}

export function* onLogout() {
  removeStore('menus')
}

/**
 * 设置根据 route config 和 menuData 设置 application
 */
export function* checkApplication({ meta = {}, path }, menuData) {
  const applicationCode =
    getAppMenuApplication(menuData)[path] || meta.applicationCode

  if (applicationCode) yield put(setApplication(applicationCode))
}

export function* checkCrumb({ meta = {}, path }, menuData, { payload }) {
  const { action, isFirstRendering } = payload
  if (isFirstRendering) {
    if (meta.layoutMode !== 'stage1' || !meta.title) return
    // A direct Stage 1 entry replaces stale persisted navigation history.
    const { pathname, key } = payload.location
    const initialCrumbList = {
      current: 0,
      stack: [{ key, list: [{ name: meta.title, path: pathname }] }]
    }
    yield put(crumbActions.init(initialCrumbList))
    setStore('crumbList', initialCrumbList)
    return
  }
  const { current, stack } = yield select(({ layout }) => layout.crumbList)

  const { pathname, key, state = {} } = payload.location
  const name = state.title || meta.title

  if (action === 'PUSH' || action === 'REPLACE') {
    const navRouteConfig = getAppMenuConfig(menuData)[path]
    let crumbList = []
    const { crumbType } = state

    const actionFn =
      navRouteConfig || crumbType === 'RESET'
        ? crumbActions.reset
        : crumbActions[action.toLowerCase()]

    if (navRouteConfig) {
      // nav route
      crumbList = [
        {
          name: navRouteConfig.name,
          path: pathname
        }
      ]
    } else if (name) {
      // default
      const baseCrumbList = state.crumbList || []

      crumbList = [
        ...baseCrumbList,
        {
          name,
          path: pathname
        }
      ]
    }

    yield put(actionFn(crumbList, key))
  } else if (action === 'POP') {
    const index = findIndex(stack, o => o.key === key)
    if (current > index) {
      yield put(crumbActions.undo(current - index))
    } else if (current < index) {
      yield put(crumbActions.redo(index - current))
    } else {
      console.error('面包屑功能报错了....请通知开发者')
    }
  }
  const crumbList = yield select(({ layout }) => layout.crumbList)
  setStore('crumbList', crumbList)
}

export function* checkLayout({ meta = {} }, _, { payload }) {
  const query = parse(payload?.location?.search)

  const layoutConfig = pick(meta, ['hideCrumb', 'layoutMode'])

  // FIXME 逻辑判断需要优化
  if (query.hideCrumb === 'true') {
    layoutConfig.hideCrumb = true
  } else if (query.hideCrumb === 'false') {
    layoutConfig.hideCrumb = false
  }

  const layoutModeEnums = ['default', 'empty', 'fixedSize']
  if (layoutModeEnums.indexOf(query.layoutMode) >= 0) {
    layoutConfig.layoutMode = query.layoutMode
  }

  yield put(setLayout(layoutConfig))
}

/**
 * global route hook
 */
export function* routeWathcer(action) {
  const { payload } = action
  const routes = matchRoutes(routers, payload.location.pathname)
  if (routes.length < 1) return

  const currentRoute = last(routes).route
  const menuData = yield select(({ layout }) => layout.menuData)
  yield checkApplication(currentRoute, menuData, action)
  yield checkCrumb(currentRoute, menuData, action)
  yield checkLayout(currentRoute, menuData, action)
}

export function* initLayout() {
  const menu = yield call(saveMenu)
  if (menu && menu.length) {
    // Rebuild workbench shortcuts when menus came from local cache during boot.
    yield call(saveWorkbenchMenu, menu)
  }
  const crumbList = getStore('crumbList')
  if (crumbList) {
    yield put(crumbActions.init(crumbList))
  }
}

export default function* watcherSaga() {
  yield takeEvery(layoutTypes.GET_APPLICATIONS, getResApplication)
  yield takeEvery('@@router/LOCATION_CHANGE', routeWathcer)
}
